import { Route, Redirect } from 'react-router-dom'
import { useContext } from 'react'
import { UserContext } from '../../hooks/UserContext'
import { userHasPermission, navigation } from '../../navigation/NavegationRoutes'
import { canAccessConfigurationsPath } from '../../components/SidebarMenu/sidebarNavigation'
import { isSuperAdminUser } from '../../utils/userUtils'

const PrivateRoute = props => {
  const { user, isLoading } = useContext(UserContext)
  const { component: Component, permission_key, ...rest } = props

  if (isLoading) {
    // An element, never a bare text node: a page translator replaces text nodes in place, and
    // React then throws NotFoundError removing one it no longer owns, taking down the whole app.
    return <div>Loading</div>
  }

  if (user?.isLogged) {
    // Routes that pass an explicit permission_key prop opt out of the
    // navigation-table lookup (used by /workforce/* sub-routes).
    if (permission_key !== undefined) {
      const allowed = permission_key === null || userHasPermission(user, permission_key) || isSuperAdminUser(user)
      if (allowed) {
        return <Route {...rest} render={props => <Component {...props} />} />
      }
      return <Redirect to="/access_denied" />
    }

    // /configurations is a navigation container; access is delegated to
    // each sub-item's own rule (canView or permission_key) instead of
    // requiring an admin role at the parent route.
    if (props.path?.includes('/configurations')) {
      if (canAccessConfigurationsPath(user, props.path)) {
        return <Route {...rest} render={props => <Component {...props} />} />
      }
      return <Redirect to="/access_denied" />
    }

    const navegation_menu = navigation.find(item => item.href == props.path && item.validate)
    if (!navegation_menu) {
      return <Route {...rest} render={props => <Component {...props} />} />
    }

    if (userHasPermission(user, navegation_menu.permission_key)) {
      return <Route {...rest} render={props => <Component {...props} />} />
    } else {
      return <Redirect to="/access_denied" />
    }
  }
  return <Redirect to={{ pathname: '/login', search: `?next=${encodeURIComponent(window.location.pathname + window.location.search)}` }} />
}

export default PrivateRoute
